export default "__VITE_ASSET__0ba85cf7__"